import { createContext } from "react";

export const ActiveEditorContext = createContext();